import { defineMessages } from "react-intl";
export default defineMessages({
    title: {
        id: "onboarding-wizard.welcome-modal.left-hand-side.page-one.title",
        defaultMessage: "Name your first project",
        description:
            "Title for page one of the modal. This modal is introduced to admins of a TMP project, to explain the hierarchy of Epics and Issues when they first land on the Board."
    },
    bodyLineOne: {
        id: "onboarding-wizard.welcome-modal.left-hand-side.page-one.body-line-one",
        defaultMessage:
            "Projects bring your work to life, helping your team track progress, stay organized, and manage tasks.",
        description:
            "The main text content within page one of the modal. This modal is introduced to admins of a TMP project, to explain the hierarchy of Epics and Issues when they first land on the Board."
    },
    getStartedBtn: {
        id: "onboarding-wizard.welcome-modal.left-hand-side.page-one.get-started-btn",
        defaultMessage: "Get started",
        description: "Button to create issues and get started"
    },
    projectNamePlaceholder: {
        id: "onboarding-wizard.welcome-modal.left-hand-side.page-one.project-name-placeholder",
        defaultMessage: "e.g. {projectName}",
        description:
            'Short form of "example" followed by the project name to be used as the placeholder text'
    },
    projectFormField: {
        id: "onboarding-wizard.welcome-modal.left-hand-side.page-one.project-form-field",
        defaultMessage: "Name your project",
        description:
            "The label for the project name field within the project name and icon form."
    },
    projectNameMinCharacterLengthError: {
        id: "onboarding-wizard.welcome-modal.left-hand-side.page-one.min-character-length-error",
        defaultMessage:
            "Too short (min. {minCharacters} {minCharacters, plural, one {character} other {characters}})",
        description:
            "Error that shows when the user has not typed enough characters for their project or space name."
    },
    projectNameMaxCharacterLengthError: {
        id: "onboarding-wizard.welcome-modal.left-hand-side.page-one.max-character-length-error",
        defaultMessage:
            "Too long (max. {maxCharacters} {maxCharacters, plural, one {character} other {characters}})",
        description:
            "Error that shows when the user has typed too many characters for their project or space name."
    },
    projectExampleHeading: {
        id: "onboarding-wizard.welcome-modal.left-hand-side.page-one.project-example-heading",
        defaultMessage: "Example project names:",
        description:
            "Title of a section that contains examples of what to name Jira projects."
    },
    projectExamples: {
        id: "onboarding-wizard.welcome-modal.left-hand-side.page-oneproject-examples",
        defaultMessage:
            "Team Astro, Visual upgrade, Bug tracking, Product launch",
        description:
            "Some examples of Jira project names that customer can use to help them name their project."
    }
});
